import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const painPoints = [<>
    Sentir ese vacío constante en el estómago y que la cabeza no para de dar
    vueltas después de cada discusión.
  </>, <>
    Dejar que el estrés de afuera (el trabajo, las cuentas, la economía) se
    filtre en la casa y termine explotando entre ustedes por cualquier pavada.
  </>, <>
    Caer en el <strong data-id="element-344" data-mp="2hsr70jm6js2p">"Cese de Fuego"</strong> constante, donde parecen más
    compañeros de cuarto que una pareja.
  </>, <>
    Acumular resentimiento por cosas del pasado que nunca se hablaron de frente
    ni se resolvieron.
  </>, <>
    Sentir que están al borde de la separación, pero en el fondo{' '}
    <strong data-id="element-345" data-mp="2mrtzl4kz45ts">no quieren tirar todo por la borda</strong>.
  </>];
export function TargetAudienceSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-24 md:py-32 bg-[#110038] relative" data-id="element-346" data-mp="sfnqcbbn3z44">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-347" data-mp="1fassy3dj8ct8">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-348" data-mp="1f86ls4ujzzbj">
          <div className="inline-block bg-[#E5A83B]/20 text-[#E5A83B] px-4 py-1.5 rounded-full text-sm font-bold tracking-wide mb-6" data-id="element-349" data-mp="22ysu7x8gzlm2">
            ¿TE SUENA FAMILIAR?
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-16 font-serif leading-tight" data-id="element-350" data-mp="2c00dp96buhw3">
            ¿Sienten que el día a día les está robando el refugio que
            construyeron juntos?
          </h2>

          <div className="bg-[#0D002B] rounded-3xl p-8 md:p-12 border border-[#7C3AED]/30 shadow-[0_10px_40px_-10px_rgba(124,58,237,0.2)] text-left" data-id="element-351" data-mp="hnajeqc1r6o6">
            <ul className="space-y-8" data-id="element-352" data-mp="1kyzr22ja7ab9">
              {painPoints.map((point, index) => <li key={index} className="flex items-start gap-4" data-id="element-353" data-mp="1g0erm5busunv" data-mpi={index}>
                  <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-354" data-mp="1tzehthf0lhm5">❌</span>
                  <span className="text-[#C4B5FD] text-lg md:text-xl font-sans leading-relaxed" data-id="element-355" data-mp="1oygxozag2di0">
                    {point}
                  </span>
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}